import { ComponentChildren, FunctionalComponent } from 'preact'
import { DesignTokens } from '../../../design-tokens'
import Icon from '../../assets'
import { Chip } from '../chip'
import ListGroup from '../list-group'

interface Props {
  pills: string[]
  dropdown: ComponentChildren
  isControl?: boolean
  onPillClick: (pill: string) => void
  id: string
  label?: string
  subtext?: string
  onClick?: (e: MouseEvent) => void
}

const MultiSelectionTagField: FunctionalComponent<Props> = ({
  pills = [],
  isControl = false,
  onPillClick,
  dropdown,
  label,
  subtext,
  id,
  onClick
}: Props) => (
  <div
    className={`o-multi-selection-tag-field o-multi-selection-tag-field--app-${
      isControl ? 'control' : 'destination'
    }`}
  >
    {label && (
      <label className='a-multi-selection-tag-field--label' for={id}>
        {label}
      </label>
    )}
    {subtext && (
      <p className='a-multi-selection-tag-field--subtext'>{subtext}</p>
    )}
    <div className='o-multi-selection-tag-field_configuration-section' onClick={onClick}>
      {pills.length > 0 && (
        <ListGroup spacing={DesignTokens.SpacingEnum.S4}>
          {pills.map((pillLabel, index) => (
            <Chip
              key={index}
              variant='squared'
              size='small'
              endIcon={<Icon icon='close' width={14} height={14} />}
              onClick={(e) => {
                e.stopPropagation()
                onPillClick(pillLabel)
              }}
            >
              {pillLabel}
            </Chip>
          ))}
        </ListGroup>
      )}
      {dropdown}
    </div>
  </div>
)

export default MultiSelectionTagField
